
// import { axiosClient } from 'src/configs/axios'

// // ============================================================
// // GET ALL PATIENTS
// // ============================================================
// export const getPatientsAPI = async (params = {}) => {
//   try {
//     console.log('📤 getPatientsAPI params:', params);
    
//     // Validate date parameters
//     const { startDate, endDate, ...otherParams } = params;
//     const validatedParams = { ...otherParams };
    
//     if (startDate && !isValidDate(startDate)) {
//       throw new Error('Invalid startDate format');
//     }
//     if (endDate && !isValidDate(endDate)) {
//       throw new Error('Invalid endDate format');
//     }
//     if (startDate && endDate) {
//       validatedParams.startDate = startDate;
//       validatedParams.endDate = endDate;
//     }
    
//     const response = await axiosClient.get('/patient', { params: validatedParams });
//     console.log('✅ getPatientsAPI response:', response.data);
//     return response;
    
//   } catch (error) {
//     console.error('❌ Error fetching patients:', {
//       message: error.response?.data?.message || error.message,
//       status: error.response?.status,
//       params,
//     });
//     throw error;
//   }
// };

// // Helper function to validate ISO date strings
// const isValidDate = (dateString) => {
//   try {
//     const date = new Date(dateString);
//     return date instanceof Date && !isNaN(date) && dateString.includes('T');
//   } catch {
//     return false;
//   }
// };

// // ============================================================
// // CREATE PATIENT
// // ============================================================
// export const createPatientAPI = async payload => {
//   try {
//     const response = await axiosClient.post('/patient/create', payload, {
//       headers: {
//         'Content-Type': 'multipart/form-data'
//       }
//     })

//     const patientId = response?.data?.patient?._id
//     return patientId
    
//   } catch (error) {

//     throw error
//   }
// }

// // ============================================================
// // EDIT PATIENT
// // ============================================================
// export const editPatientAPI = async (id, payload) => {
//   try {
//     const response = await axiosClient.patch(`/patient/${id}`, payload)
//     return response?.data
    
//   } catch (error) {
//     throw error
//   }
// }

// // ============================================================
// // DELETE PATIENT
// // ============================================================
// export const deletePatientAPI = async id => {
//   try {
  
//     const response = await axiosClient.delete(`/patient/${id}`)

//     return response?.data
    
//   } catch (error) {

//     throw error
//   }
// }

// // ============================================================
// // GET SINGLE PATIENT
// // ============================================================
// export const getSinglePatient = async id => {
//   try {

//     const response = await axiosClient.get(`/patient/${id}`)

//     return response?.data
    
//   } catch (error) {

//     throw error
//   }
// }

// // ============================================================
// // GET ASSIGNEES
// // ============================================================
// export const getAssigneesAPI = async () => {
//   try {
  
//     const response = await axiosClient.get('/jwt/getUser')
//     return response?.data
    
//   } catch (error) {
//     throw error
//   }
// }

// // ============================================================
// // ASSIGN PATIENT - ✅ FIXED
// // ============================================================
// const pickId = (x) => {
//   if (!x) return null;
//   if (typeof x === 'string') return x;
//   if (typeof x === 'object') return x._id ?? x.id ?? null;
//   return null;
// };

// export const assignPatientAPI = async (patient, assignee) => {
//   try {
//     const patientId = pickId(patient);
//     const assigneeId = pickId(assignee);
    
    
//     if (!patientId || !assigneeId) {
//       throw new Error('Missing patientId or assigneeId');
//     }

//     // ✅ CRITICAL FIX: Backend expects only assigneeId in body
//     const payload = {
//       assigneeId: assigneeId
//     };
    
 
    
//     const response = await axiosClient.patch(`/patient/${patientId}/assign`, payload);
    
    
//     return response?.data;
    
//   } catch (error) {
//     console.error(`❌ Error assigning patient:`, {
//       patientId: pickId(patient),
//       assigneeId: pickId(assignee),
//       error: error.response?.data || error.message
//     });
//     throw error;
//   }
// }

// // ============================================================
// // GET ASSIGNED PATIENTS - ✅ FIXED
// // ============================================================
// export const getAssignedPatientsAPI = async () => {
//   try {

    
//     const response = await axiosClient.get('/patient/assigned');
    
    
//     // ✅ FIXED: Handle backend response structure from getPatientsByAsigneeId.js
//     // Backend returns: { success: true, patients: [...] }
//     let patients = [];
    
//     if (response.data.success && Array.isArray(response.data.patients)) {
     
//       patients = response.data.patients;
//     } else if (Array.isArray(response.data.patients)) {
     
//       patients = response.data.patients;
//     } else if (Array.isArray(response.data)) {
    
//       patients = response.data;
//     } else if (Array.isArray(response.data.documents)) {
     
//       patients = response.data.documents;
//     } else {
     
//     }
    
    
//     // ✅ Always return in consistent format for the action
//     return {
//       data: {
//         patients: patients
//       }
//     };
    
//   } catch (error) {
//     console.error('❌ ERROR in getAssignedPatientsAPI:', {
//       message: error.response?.data?.message || error.message,
//       status: error.response?.status,
//       statusText: error.response?.statusText,
//       endpoint: '/patient/assigned',
//       responseData: error.response?.data,
//       fullError: error
//     });
    
//     // Re-throw so the thunk can handle it
//     throw error;
//   }
// };

import { axiosClient } from 'src/configs/axios'

// ============================================================
// GET ALL PATIENTS
// ============================================================
export const getPatientsAPI = async (params = {}) => {
  try {
    const { startDate, endDate, ...otherParams } = params;
    const validatedParams = { ...otherParams };

    if (startDate && !isValidDate(startDate)) {
      throw new Error('Invalid startDate format');
    }
    if (endDate && !isValidDate(endDate)) {
      throw new Error('Invalid endDate format');
    }
    if (startDate && endDate) {
      validatedParams.startDate = startDate;
      validatedParams.endDate = endDate;
    }

    return await axiosClient.get('/patient', { params: validatedParams });

  } catch (error) {
    throw error;
  }
};

// Helper function to validate ISO date strings
const isValidDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date) && dateString.includes('T');
  } catch {
    return false;
  }
};

// ============================================================
// CREATE PATIENT
// ============================================================
export const createPatientAPI = async payload => {
  try {
    const response = await axiosClient.post('/patient/create', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response?.data?.patient?._id;

  } catch (error) {
    throw error;
  }
};

// ============================================================
// EDIT PATIENT
// ============================================================
export const editPatientAPI = async (id, payload) => {
  try {
    const response = await axiosClient.patch(`/patient/${id}`, payload);
    return response?.data;

  } catch (error) {
    throw error;
  }
};

// ============================================================
// DELETE PATIENT
// ============================================================
export const deletePatientAPI = async id => {
  try {
    const response = await axiosClient.delete(`/patient/${id}`);
    return response?.data;

  } catch (error) {
    throw error;
  }
};

// ============================================================
// GET SINGLE PATIENT
// ============================================================
export const getSinglePatient = async id => {
  try {
    const response = await axiosClient.get(`/patient/${id}`);
    return response?.data;

  } catch (error) {
    throw error;
  }
};

// ============================================================
// GET ASSIGNEES
// ============================================================
export const getAssigneesAPI = async () => {
  try {
    const response = await axiosClient.get('/jwt/getUser');
    return response?.data;

  } catch (error) {
    throw error;
  }
};

// ============================================================
// ASSIGN PATIENT
// ============================================================
const pickId = (x) => {
  if (!x) return null;
  if (typeof x === 'string') return x;
  if (typeof x === 'object') return x._id ?? x.id ?? null;
  return null;
};

export const assignPatientAPI = async (patient, assignee) => {
  try {
    const patientId = pickId(patient);
    const assigneeId = pickId(assignee);

    if (!patientId || !assigneeId) {
      throw new Error('Missing patientId or assigneeId');
    }

    const response = await axiosClient.patch(`/patient/${patientId}/assign`, { assigneeId });
    return response?.data;

  } catch (error) {
    throw error;
  }
};

// ============================================================
// GET ASSIGNED PATIENTS
// ============================================================
export const getAssignedPatientsAPI = async () => {
  try {
    const response = await axiosClient.get('/patient/assigned');
    const { data } = response;

    let patients = [];

    if (Array.isArray(data?.patients)) {
      patients = data.patients;
    } else if (Array.isArray(data)) {
      patients = data;
    } else if (Array.isArray(data?.documents)) {
      patients = data.documents;
    }

    return { data: { patients } };

  } catch (error) {
    throw error;
  }
};